import { AppAlert } from '@components/antd';
import { useModal } from '@shared/hooks/use-modal';
import MicPermissionModal from '../../modal/modal-mic-permisssion';
import { Trans } from 'react-i18next';

export const MicPermissionBanner = () => {
  const { open, handleOpen, handleClose } = useModal();

  return (
    <>
      <AppAlert
        showIcon
        type="warning"
        message={
          <p>
            <Trans
              i18nKey="allow_calilio_to_access_your_microphone_to_continue_calling_learn_more"
              components={[
                <span key="learn-more" className="cursor-pointer text-amber-700" onClick={handleOpen}></span>,
              ]}
            />
          </p>
        }
      />

      <MicPermissionModal open={open} onClose={handleClose} />
    </>
  );
};
